import { render, staticRenderFns } from "./doctorMessageClinic.vue?vue&type=template&id=06792f44&scoped=true&"
import script from "./doctorMessageClinic.vue?vue&type=script&lang=js&"
export * from "./doctorMessageClinic.vue?vue&type=script&lang=js&"
import style0 from "./doctorMessageClinic.vue?vue&type=style&index=0&id=06792f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06792f44",
  null
  
)

export default component.exports